export default "__VITE_ASSET__fb0ba60a__"